'use client';

import { DateTime } from 'luxon';
import { useTheme } from '@emotion/react';
import { useEffect, useState } from 'react';
import { filterDateArr, filterDates } from '../../lib/consts';
import { H1 } from '../styled/typography';
import Calendar from '../calendar/calendar';
import CheckSVG from '../../public/img/check-red.svg';
import { FilterQuery } from '../../models/filters';

export default function TimeFilter({
  query,
  setQuery,
  filtersData,
}: {
  query: FilterQuery;
  setQuery: (query: FilterQuery) => void;
  filtersData: number | null;
}) {
  const theme = useTheme();
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [timeActive, setTimeActive] = useState<number | null>(null);
  const [dates, setDates] = useState<[string, string] | null>(null);

  useEffect(() => {
    setTimeActive(filtersData);
    if (filtersData !== -1 && filtersData !== null) {
      setDates(filterDates[filtersData]);
    } else if (
      filtersData === -1 &&
      typeof query.filters.date_from === 'string' &&
      typeof query.filters.date_to === 'string'
    ) {
      setDates([query.filters.date_from, query.filters.date_to]);
    }
  }, [filtersData]);

  const onChangeDateFilter = (
    value?: number,
    dateFrom?: string,
    dateTo?: string
  ) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let date_from: string | [] = [];
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let date_to: string | [] = [];
    switch (value) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4: {
        date_from = dateFrom || '';
        date_to = dateTo || '';
        break;
      }
      case 5: {
        date_from = DateTime.fromFormat(dateFrom || '', 'dd.LL.yyyy').toFormat(
          'yyyy-LL-dd'
        );
        date_to = DateTime.fromFormat(dateTo || '', 'dd.LL.yyyy').toFormat(
          'yyyy-LL-dd'
        );
        break;
      }
      default:
        date_to = [];
        date_from = [];
        break;
    }
    setQuery({
      ...query,
      dateFilterId: query.dateFilterId === value ? null : value,
      filters: {
        ...query.filters,
        date_from,
        date_to,
        pages: [],
      },
      isDataFromServer: false,
    });

    const index = Array.from({
      ...filterDates,
      length: Object.keys(filterDateArr).length,
    }).findIndex((item: any) => item[0] === date_from && item[1] === date_to);
    setTimeActive(index);
  };

  return (
    <div
      css={{
        marginRight: 8,
      }}
    >
      <H1
        css={{
          fontFamily: 'Montserrat',
          fontSize: '24px !important',
          fontWeight: 900,
        }}
      >
        Когда
      </H1>

      <div
        css={{
          width: '100%',
          height: 2,
          boxShadow: '0 1px 1px rgba(0, 0, 0, 0.05)',
          marginTop: 14,
        }}
      />
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
      >
        {filterDateArr.map((item) => (
          <button
            type='button'
            key={`datetime-filter-${item.id}`}
            css={{
              width: '100%',
              height: 75,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              boxShadow: '0 1px 1px rgba(0, 0, 0, 0.05)',
              textAlign: 'left',
              fontSize: 18,
              fontWeight: 700,
              fontFamily: 'Montserrat',
              color: '#333',
              letterSpacing: 0,
            }}
            onClick={() => {
              setCalendarIsOpen(false);
              if (query.dateFilterId === item.id) {
                onChangeDateFilter();
              } else {
                onChangeDateFilter(item.id, ...filterDates[item.id]);
              }
            }}
          >
            {item.title}

            {item.id === timeActive && <CheckSVG />}
          </button>
        ))}

        <div
          // filter__calendar filter__calendar_desktop
          css={{
            // marginLeft: 0,
            width: '100%',
            marginTop: 4.5,
            marginBottom: 4.5,
            position: 'relative',
          }}
        >
          <div
            // filter__calendar-btn
            css={{
              width: '100%',
              height: 75,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              boxShadow: '0 1px 1px rgba(0, 0, 0, 0.05)',
              textAlign: 'left',
              fontSize: 18,
              fontWeight: 700,
              fontFamily: 'Montserrat',
              color: '#333',
              letterSpacing: 0,
              cursor: 'pointer',
            }}
            onClick={() => setCalendarIsOpen(!calendarIsOpen)}
          >
            Дата
            {timeActive === -1 && <CheckSVG />}
          </div>
          {calendarIsOpen && (
            <div
              css={{
                width: '100%',
                // zIndex: 99,
                background: theme.colors.white,
                marginTop: 4,
                overflow: 'hidden',
                transition: '.3s ease-in-out',
                ...(calendarIsOpen
                  ? {
                      maxHeight: '600px',
                      '.popup__calendar-link-control:before': {
                        display: 'block',
                      },
                    }
                  : {
                      maxHeight: 0,
                      '.popup__calendar-link-control:before': {
                        display: 'none',
                      },
                    }),
              }}
              // filter__dropdown-body
            >
              <Calendar
                onDatePicked={(values) =>
                  values
                    ? onChangeDateFilter(5, ...values)
                    : onChangeDateFilter()
                }
                enableClear
                initDates={
                  query.filters.date_from.length && query.filters.date_to.length
                    ? [
                        DateTime.fromFormat(
                          query.filters.date_from as string,
                          'yyyy-LL-dd'
                        ).toFormat('dd.LL.yyyy'),
                        DateTime.fromFormat(
                          query.filters.date_to as string,
                          'yyyy-LL-dd'
                        ).toFormat('dd.LL.yyyy'),
                      ]
                    : null
                }
                additionalCss={{ padding: '24px 0' }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
